import type { SVGProps } from 'react';

export const BarChartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      id="icon/editor/bar_chart_24px"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.83341 4.16663H11.1667V15.8333H8.83341V4.16663ZM4.16675 7.66663H6.66675V15.8333H4.16675V7.66663ZM15.8334 10.8333H13.5001V15.8333H15.8334V10.8333Z"
      fill={props.fill ?? 'white'}
    />
  </svg>
);

export default BarChartIcon;
